import { Form, Input } from "antd";
import WrappingModal from "../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  units: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
}

const FormModal = ({
  form,
  units,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل وحدة" : "إضافة وحدة"}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOk}
        initialValues={initialValues}
        className="grid grid-cols-1 gap-3"
      >
        {/* In edit mode, display the UnitID as disabled */}
        {isEditing && (
          <Form.Item
            name="UnitID"
            label="كود الوحدة"
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
        )}

        {/* Unit Name */}
        <Form.Item
          name="UnitName"
          label="اسم الوحدة"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
